export default "__VITE_ASSET__COnfsdc1__"